import { pick, path } from 'ramda';
import { useCallback } from 'react';
import { getCleanPath, getCleanUrl } from 'js/utils/url.util';
import { useAppSelector } from 'js/store/hooks';

export const useIsPageInPopupUrl = () => {
    const {
        pageInPopupUrls,
        quickDepositPage,
        quickDepositUseCustom,
        gamesGridViewMorePageURL,
        gamesGridGameInfoPageURL
    } = useAppSelector(
        pick(['pageInPopupUrls', 'quickDepositPage', 'quickDepositUseCustom', 'gamesGridViewMorePageURL', 'gamesGridGameInfoPageURL'])
    );
    const bonusPage = getCleanPath(useAppSelector(
        path(['bonusManagementPreferences', 'bonusDeepLinkingUrl'])
    ) || 'promotions');

    return useCallback(() => {
        // can't use useLocation here in order to BB compatibility
        const pathname = getCleanUrl(window.location.pathname);
        const isStaticPageInPopup = pathname.includes('/online-game/');
        const isBonusPage = pathname.startsWith(`${bonusPage}/`);
        const isGamesGridViewMorePage = pageInPopupUrls?.includes(gamesGridViewMorePageURL) && pathname.startsWith(`${gamesGridViewMorePageURL}/`);
        const isGamesGridInfoPage = pageInPopupUrls?.includes(gamesGridGameInfoPageURL) && pathname.startsWith(`${gamesGridGameInfoPageURL}/`);

        return pageInPopupUrls?.includes(pathname)
            || pathname === quickDepositPage && !quickDepositUseCustom
            || isStaticPageInPopup
            || isBonusPage
            || isGamesGridInfoPage
            || isGamesGridViewMorePage;
    }, [pageInPopupUrls, quickDepositUseCustom, quickDepositPage, bonusPage, gamesGridViewMorePageURL, gamesGridGameInfoPageURL]);
};
